import React from 'react'
import compose from 'recompose/compose'
import _ from 'lodash'
import moment from 'moment'
import { withI18n } from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import { DateInput, TimeInput, InputEditor } from '../../atoms'
import { SimpleDialog } from '../../molecules'
import ActionDialog from '../action-dialog'
import * as api from '../../../api'

const ModalRequireDoc = ({ open, handleClose, i18n, onSubmit }) => {
  const [openPopup, setOpenPopup] = React.useState(false)
  const [message, setMessage] = React.useState('')
  const [date, setDate] = React.useState(new Date())
  const [time, setTime] = React.useState(moment().format('HH:mm'))

  const [defaultMessages, setDefaultMessages] = React.useState([])

  React.useEffect(() => {
    const fetchData = async () => {
      const result = await api.getDefaultMessages()
      setDefaultMessages(result)
    }
    fetchData()
  }, [])

  function handleClickOpenPopup() {
    setOpenPopup(true)
  }

  const handleClosePopup = value => {
    setOpenPopup(false)

    if (value) {
      const body = value.body || ''

      setMessage(body)
    }
  }

  const clear = () => {
    setMessage('')
    setDate(new Date())
    setTime(moment().format('HH:mm'))
  }

  const handleSubmit = e => {
    e && e.preventDefault()

    const limit_date = new moment(`${moment(date).format('YYYY/DD/MM')} ${time}`, 'YYYY/DD/MM HH:mm').format('YYYY-MM-DD HH:mm:ss')

    // El modal se cierra cuando la petición del padre ha ido bien; si falla sigue abierto
    return Promise.resolve(onSubmit({
      message,
      limit_date,
    })).then(() => {
      handleClose()
      clear()
    })
  }

  const submitDisabled = _.isEmpty(message)
  return (
    <ActionDialog
      open={open}
      title={i18n.modalRequireDoc.requireDoc}
      onClose={handleClose}
      onConfirm={handleSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.modalRequireDoc.sendRequireDoc}
      confirmDisabled={submitDisabled}
      disableBackdropClose
    >
      <S.Body>
        <S.DateRow>
          <S.DateField>
            <label>{i18n.modalRequireDoc.limitDate}</label>
            <DateInput fontSize="small" name="date" onChange={e => setDate(e)} value={date} />
          </S.DateField>
          <S.TimeField>
            <TimeInput fontSize="small" name="time" onChange={e => setTime(e.target.value)} value={time} />
          </S.TimeField>
        </S.DateRow>
        <div>
          <label>{i18n.modalRequireDoc.infoToUpload}</label>
          <InputEditor
            fontSize="small"
            placeholder={i18n.modalRequireDoc.writeInfoToUpload}
            name="message"
            value={message}
            onChange={value => setMessage(value)}
          />
        </div>
        <S.DefaultMessagesLink type="button" onClick={handleClickOpenPopup}>{i18n.modalRequireDoc.defaultMessages}</S.DefaultMessagesLink>
        <SimpleDialog defaultMessages={defaultMessages} open={openPopup} onClose={handleClosePopup} />
      </S.Body>
    </ActionDialog>
  )
}

ModalRequireDoc.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
}

const enharce = compose(withI18n)

export default enharce(ModalRequireDoc)
